import React from 'react';
import { useParams } from 'react-router-dom';

const AdminInviteTest = () => {
    const { token } = useParams();
    
    return (
        <div className="flex items-center justify-center min-h-screen bg-[#0A192F]">
            <div className="bg-[#112240] rounded-xl p-8 max-w-md w-full">
                <h1 className="text-2xl font-bold text-[#64FFDA] mb-4">Admin Invitation Test</h1>
                <p className="text-gray-300 mb-6">
                    Token: {token}
                </p>
                <p className="text-gray-300">
                    This is a test page to verify routing works.
                </p>
            </div>
        </div>
    );
};

export default AdminInviteTest; 